import { render } from "./AddWiFiProfile.vue?vue&type=template&id=1906d066"
import script from "./AddWiFiProfile.vue?vue&type=script&lang=js"
export * from "./AddWiFiProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__